#import "../../../editions/graphql/fragments/template-stub-fragment.graphql"

mutation TemplateDuplicate($edition: EditionDuplicateToTemplateInput!) {
    editionDuplicateToTemplate(input: $edition) {
        template {
            ...TemplateStubFragment
        }
    }
}
